import BookingApi from '../../apis/booking';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreateBookingParams } from '../../params/redux/booking';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import { resettingBookingLoader } from '../slices/booking';
import { RootState } from '../store';

export const fetchBookingDetailThunk = createAsyncThunk(
    'booking/detail',
    async (event_id: string, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await BookingApi.fetchEventDetail(state.app.token, event_id);
            if (response?.success === 1) {
                return response?.calendar_details;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingBookingLoader());
        }
    }
);

export const fetchBookingSlotsDetailThunk = createAsyncThunk(
    'booking/slot-detail',
    async ({ eventId, date, time_zone }: { eventId: string; date: string, time_zone: string }, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await BookingApi.fetchSlotDetails(state.app.token, eventId, date, time_zone);
            if (response?.success === 1) {
                return response?.availability_hours;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingBookingLoader());
        }
    }
);

export const createBookingThunk = createAsyncThunk(
    'booking/create',
    async (data: CreateBookingParams, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await BookingApi.createBooking(state.app.token, data);
            if (response?.success === 1) {
                return true;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingBookingLoader());
        }
    }
);
